import { Box, LinearProgress, Stack } from '@mui/material';
import { AgronodButton, AgronodCard, AgronodTypography } from '@agronod/mui-components';

interface Props {
  valda: number;
  /** Det låsta antalet gårdar som ska väljas. */
  antal: number;
  upptagen?: boolean;
  onRensa: () => void;
  onBekrafta: () => void;
}

/**
 * Klistrad urvalsbar i revisionsledarens urvalsläge: hur många gårdar som
 * är valda av det låsta antalet, förlopp och knappen som öppnar
 * bekräftelsen (aktiv först när exakt antalet är valt).
 */
export const UrvalsBar = ({ valda, antal, upptagen = false, onRensa, onBekrafta }: Props) => {
  const fullt = antal > 0 && valda >= antal;
  const kvar = antal - valda;
  return (
    <AgronodCard
      sx={{
        px: 3,
        py: 2,
        mb: 3,
        position: 'sticky',
        top: 16,
        zIndex: 4,
        boxShadow: '0px 4px 30px rgba(0, 0, 0, 0.05)',
      }}
    >
      <Stack
        direction="row"
        useFlexGap
        sx={{
          alignItems: 'center',
          justifyContent: 'space-between',
          flexWrap: 'wrap',
          gap: 3,
        }}
      >
        <Box sx={{ flex: 1, minWidth: 220, maxWidth: 420 }}>
          <Stack
            direction="row"
            useFlexGap
            sx={{ alignItems: 'baseline', flexWrap: 'wrap', gap: 1, mb: 1 }}
          >
            <AgronodTypography
              variant="h5"
              component="span"
              sx={{ fontVariantNumeric: 'tabular-nums' }}
            >
              {valda} av {antal}
            </AgronodTypography>
            <AgronodTypography variant="body2" sx={{ color: 'text.secondary' }}>
              gårdar valda för revision
            </AgronodTypography>
          </Stack>
          <LinearProgress
            variant="determinate"
            color="primary"
            value={antal > 0 ? Math.min(100, (valda / antal) * 100) : 0}
            aria-label="Andel av antalet valt"
            sx={{ height: 6, borderRadius: 3 }}
          />
        </Box>
        <Stack direction="row" spacing={1} sx={{ alignItems: 'center' }}>
          {valda > 0 && (
            <AgronodButton variant="text" onClick={onRensa} disabled={upptagen}>
              Rensa val
            </AgronodButton>
          )}
          <AgronodButton
            variant="contained"
            disabled={!fullt || upptagen}
            onClick={onBekrafta}
            sx={{ whiteSpace: 'nowrap', flexShrink: 0 }}
          >
            {fullt ? `Välj ut ${antal} gårdar för revision` : `Välj ${kvar} till`}
          </AgronodButton>
        </Stack>
      </Stack>
    </AgronodCard>
  );
};
